import React from "react";
import { LineChart, Line, ResponsiveContainer } from "recharts";
import styles from "./Styles.module.scss"; // SCSS file for styling

const StatCard = ({ title, value, color, data, Line, isSelected, titleValue, firstCard }) => {
    return (
        <div className={`${styles.statCard} ${isSelected ? styles.selected : ""}`}>
            <div className="d-flex justify-content-between">
                <div className={styles.header}>{title}</div>
                {titleValue &&
                    <div className={` ${firstCard ? styles.titleValue : styles.titleValue1} `}>{titleValue}</div>
                }
            </div>
            <div className={styles.content}>
                <span className={styles.value}>${value}</span>
                {Line &&
                    <div className={styles.chart}>
                          <img src={Line} className={styles.img} />
                    </div>
                }
            </div>
        </div>
    );
};

export default StatCard;
